var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 799.928,
    height: 517.158,
    viewBox: "0 0 799.928 517.158",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-505.001 -238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.4,72.335a67.714,67.714,0,1,0-88,64.619l2.263,130.317,103.5-102.155s-40.355-15.625-48.086-36.33A67.641,67.641,0,0,0,304.4,72.335Z",
    transform: "translate(880.833 314.404)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.978,128.577s23.1-8.228,34.948-32.259C345.8,74.245,347,36.643,316.109,27.511c0,0,17.8-15.365-15.014-24.725l4.364,4.027S301.609-.143,282.59,3.97c0,0-70.276-8.185-82.749,14.954,0,0-37.718,7.73-17.632,36.422,0,0,1.038,5.583,8.205,5.478l-3.581-4.683,10.913,4.683s15.178-24.176,29.5-10.808c0,0,27.4-1.153,40.5-3.553,0,0-2.63,35.194,22.52,42.048s9.707,40.068,9.707,40.068Z",
    transform: "translate(854.625 314.653)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.732,396.776,505.5,470.606l10.292-47.967L398.521,366.922c-2.221-8.43-8.363-16.492-17.472-21.615-15.939-8.963-34.873-5.537-42.291,7.654s-.511,31.15,15.428,40.113C363.3,398.2,373.375,399.257,381.732,396.776Z",
    transform: "translate(540.531 273.881)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.724,167.618c-28.526,28.663-55.615,36.357-80.539,12.459l-35.2,257.945,14.636,21.207,89.012.254,12.093-291.865Z",
    transform: "translate(869.394 294.728)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.07,164.467,85.955,176.69l45.188,25.769a67.3,67.3,0,0,1,40.826,43.032,404.991,404.991,0,0,1,15.3,71.058C194.7,377.48,189.3,457.822,189.3,457.822l-68.7.6,2.987-40.29,11.052-99.679-.293,140.222H54.293s-5.479-237.827,6.46-290.717a6.406,6.406,0,0,1,10.318-3.488Z",
    transform: "translate(1113.733 295.285)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.855,181.787l-54.131,26.029A66.017,66.017,0,0,0,316.672,254l-22.68,110.162L286.579,430.8s31.888,28.559,52.814,19.089L337.9,460.94h48.389l20.566-279.153Z",
    transform: "translate(692.724 293.018)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.145,405.423l-63.623-35.246L363.3,420.656s36.573,45.314,93.791,51.973l-11.948-67.207Z",
    transform: "translate(575.025 270.276)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.779,473.489c12.8-21.678,17.17-39,23.454-63.371a273.908,273.908,0,0,0,8.617-74.368,264.616,264.616,0,0,0-4.286-42.007c-.305-1.659,2.236-2.371,2.544-.7a268.938,268.938,0,0,1,4.227,37.807A272.946,272.946,0,0,1,371.2,368.9a278.925,278.925,0,0,1-6.291,37.341A273.721,273.721,0,0,1,353.5,442.56c-4.64,11.808-3.935,17.144-10.2,28.179q-1.164,2.051-2.365,4.081a1.32,1.32,0,0,1-2.278-1.331h-.879Z",
    transform: "translate(687.475 279.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.531,374.252a47.313,47.313,0,0,0,31.915,22.818c1.665.321.96,2.864-.7,2.544a49.871,49.871,0,0,1-33.492-24.03,1.32,1.32,0,0,1,2.278-1.331h0Z",
    transform: "translate(581.306 269.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.276,481.963c1.33-13.593.383-27.425-.868-40.993a345.005,345.005,0,0,0-7.2-46.472,129.571,129.571,0,0,0-6.076-20.1c-.577-1.4,1.971-2,2.544-.614a123.069,123.069,0,0,1,5.518,17.76c1.793,7.344,3.208,14.758,4.409,22.193a373.729,373.729,0,0,1,4.73,47.137,161.556,161.556,0,0,1-.415,21.093c-.144,1.47-2.783,1.483-2.638,0h0Z",
    transform: "translate(1089.738 269.936)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.626,470.8l98.02,11.2-9.409-37.636-86.92-7.776c-5.752-6.551-14.847-11.022-25.285-11.538-18.264-.9-33.675,10.618-34.423,25.733s13.453,28.1,31.717,29c10.438.516,19.93-3.037,26.3-8.988Z",
    transform: "translate(967.014 263.658)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1,431.911l-68.519-2.969,5.882,50.622s49.936,23,101.015,4.389L153.1,431.911Z",
    transform: "translate(1085.721 261.859)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.83,181.386,201.976,436.778l-3.037-4.4,35.2-257.945c22.772,21.835,47.352,17.3,73.182-5.51a4.166,4.166,0,0,1,6.924,3.052c-27.381,26.125-53.4,32.435-77.418,9.41Z",
    transform: "translate(862.391 294.698)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.577,534.7a1.234,1.234,0,0,1-1.234-1.234v-50.6a1.234,1.234,0,1,1,2.468,0v50.6A1.234,1.234,0,0,1,523.577,534.7Z",
    transform: "translate(278.251 78.512)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.512,474.846a1.229,1.229,0,0,1-.62-.167l-70.121-40.857a1.234,1.234,0,1,1,1.243-2.133l70.122,40.857a1.234,1.234,0,0,1-.623,2.3Z",
    transform: "translate(264.623 66.777)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.578,474.846a1.234,1.234,0,0,1-.623-2.3l70.121-40.857a1.234,1.234,0,0,1,1.243,2.133L409.2,474.679A1.233,1.233,0,0,1,408.578,474.846Z",
    transform: "translate(251.317 66.777)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.512,524.846a1.226,1.226,0,0,1-.62-.167l-70.122-40.857a1.234,1.234,0,1,1,1.243-2.133l70.122,40.857a1.234,1.234,0,0,1-.622,2.3Z",
    transform: "translate(278.441 78.487)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.578,524.846a1.234,1.234,0,0,1-.623-2.3l70.121-40.857a1.234,1.234,0,1,1,1.243,2.133L468.2,524.679a1.233,1.233,0,0,1-.62.168Z",
    transform: "translate(265.134 78.487)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.6,424.615a1.234,1.234,0,0,1-1.234-1.231l-.114-44.909a1.234,1.234,0,0,1,1.231-1.237h0a1.234,1.234,0,0,1,1.234,1.231l.114,44.909a1.234,1.234,0,0,1-1.231,1.237Z",
    transform: "translate(264.645 54.064)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.432,439.783H453.278a5.56,5.56,0,0,1-5.554-5.554V417.713a5.56,5.56,0,0,1,5.554-5.554h32.154a5.56,5.56,0,0,1,5.554,5.554v16.515A5.56,5.56,0,0,1,485.432,439.783Z",
    transform: "translate(260.773 62.242)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.375,366.989H379.958a1.234,1.234,0,0,1,0-2.468h68.416a1.234,1.234,0,0,1,0,2.468Z",
    transform: "translate(244.613 51.085)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.484,360.813a1.234,1.234,0,0,1-1.234-1.234V316.859a1.234,1.234,0,1,1,2.468,0v42.719a1.234,1.234,0,0,1-1.234,1.234Z",
    transform: "translate(264.645 39.633)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.995,374.46a1.229,1.229,0,0,1-.628-.172l-66.419-39.366a1.234,1.234,0,1,1,1.259-2.124l66.419,39.366a1.234,1.234,0,0,1-.63,2.3Z",
    transform: "translate(226.958 43.614)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.578,406.355a1.234,1.234,0,0,1-.631-2.3l66.419-39.366a1.234,1.234,0,0,1,1.259,2.124l-66.419,39.366A1.229,1.229,0,0,1,304.578,406.355Z",
    transform: "translate(226.958 51.085)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.912,390.86H363.4a5.56,5.56,0,0,1-5.554-5.554V353.153A5.56,5.56,0,0,1,363.4,347.6h16.515a5.56,5.56,0,0,1,5.554,5.554v32.153A5.56,5.56,0,0,1,379.912,390.86Z",
    transform: "translate(239.724 47.122)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.432,324.558H453.278A5.56,5.56,0,0,1,447.724,319V302.488a5.56,5.56,0,0,1,5.554-5.554h32.154a5.56,5.56,0,0,1,5.554,5.554V319a5.56,5.56,0,0,1-5.554,5.554Z",
    transform: "translate(260.773 35.255)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.912,359.86H288.4a5.56,5.56,0,0,1-5.554-5.554V322.153A5.56,5.56,0,0,1,288.4,316.6h16.516a5.56,5.56,0,0,1,5.554,5.554v32.153A5.56,5.56,0,0,1,304.912,359.86Z",
    transform: "translate(222.158 39.861)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.912,422.86H288.4a5.56,5.56,0,0,1-5.554-5.554V385.153A5.56,5.56,0,0,1,288.4,379.6h16.516a5.56,5.56,0,0,1,5.554,5.554v32.153A5.56,5.56,0,0,1,304.912,422.86Z",
    transform: "translate(222.158 54.617)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.993,366.989H495.577a1.234,1.234,0,1,1,0-2.468h68.416a1.234,1.234,0,0,1,0,2.468Z",
    transform: "translate(271.692 51.085)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.236,41.835a1.234,1.234,0,0,1-.63-2.3L67.024.173A1.234,1.234,0,0,1,68.282,2.3L1.864,41.663a1.228,1.228,0,0,1-.628.172Z",
    transform: "translate(689.457 332.189) rotate(-90)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.652,41.835a1.228,1.228,0,0,1-.628-.172L.605,2.3A1.234,1.234,0,0,1,1.863.173L68.282,39.539a1.234,1.234,0,0,1-.63,2.3Z",
    transform: "translate(728.824 332.189) rotate(-90)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.069,43.261H5.554A5.56,5.56,0,0,1,0,37.707V5.554A5.56,5.56,0,0,1,5.554,0H22.069a5.56,5.56,0,0,1,5.554,5.554V37.707a5.56,5.56,0,0,1-5.554,5.554Z",
    transform: "translate(669.678 265.624) rotate(-90)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.069,43.261H5.554A5.56,5.56,0,0,1,0,37.707V5.554A5.56,5.56,0,0,1,5.554,0H22.069a5.56,5.56,0,0,1,5.554,5.554V37.707A5.56,5.56,0,0,1,22.069,43.261Z",
    transform: "translate(747.433 265.623) rotate(-90)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.432,490.783H395.278a5.56,5.56,0,0,1-5.554-5.554V468.713a5.56,5.56,0,0,1,5.554-5.554h32.154a5.56,5.56,0,0,1,5.554,5.554v16.515a5.56,5.56,0,0,1-5.554,5.554Z",
    transform: "translate(247.191 74.187)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.247,490.783H511.093a5.56,5.56,0,0,1-5.554-5.554V468.713a5.56,5.56,0,0,1,5.554-5.554h32.153a5.56,5.56,0,0,1,5.554,5.554v16.515A5.56,5.56,0,0,1,543.247,490.783Z",
    transform: "translate(274.315 74.187)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.247,539.783H458.093a5.56,5.56,0,0,1-5.554-5.554V517.713a5.56,5.56,0,0,1,5.554-5.554h32.154a5.56,5.56,0,0,1,5.554,5.554v16.515A5.56,5.56,0,0,1,490.247,539.783Z",
    transform: "translate(261.901 85.663)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.247,539.783H569.093a5.56,5.56,0,0,1-5.554-5.554V517.713a5.56,5.56,0,0,1,5.554-5.554h32.154a5.56,5.56,0,0,1,5.554,5.554v16.515a5.56,5.56,0,0,1-5.554,5.554Z",
    transform: "translate(287.897 85.663)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.247,539.783H511.093a5.56,5.56,0,0,1-5.554-5.554V517.713a5.56,5.56,0,0,1,5.554-5.554h32.153a5.56,5.56,0,0,1,5.554,5.554v16.515A5.56,5.56,0,0,1,543.247,539.783Z",
    transform: "translate(274.315 85.663)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.807,391.065H434.635a5.56,5.56,0,0,1-5.554-5.554V353.679a5.56,5.56,0,0,1,5.554-5.554h78.173a5.56,5.56,0,0,1,5.554,5.554v31.833a5.56,5.56,0,0,1-5.554,5.554Z",
    transform: "translate(256.407 47.245)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.807,391.065H434.635a5.56,5.56,0,0,1-5.554-5.554V353.679a5.56,5.56,0,0,1,5.554-5.554h78.173a5.56,5.56,0,0,1,5.554,5.554v31.833a5.56,5.56,0,0,1-5.554,5.554Z",
    transform: "translate(407.838 47.245)",
    fill: "#e6e6e6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.8855e3cb846749cb7bf776b22e13b3da.svg";
export { ForwardRef as ReactComponent };